export default __webpack_public_path__ + "static/media/vilciens.106048f9.jpg";